module.exports = __webpack_public_path__ + "img/gpay-icon-black.ec19cdad.svg";